import { Accordion, Card } from 'react-bootstrap';
import Styled from 'styled-components';
import { Element } from 'react-scroll';

export const StyledNoRecordsFound = Styled.div`
    display: flex;
    justify-content: center;
    margin: 100px 0;
    align-items: center;
`;

export const StyledGrid = Styled.div`
    display: grid;
    grid-template-columns: ${({ columns }) => `repeat(${columns}, 1fr)`};
    gap: 16px;
    width: 100%;
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 0;
    }
`;

export const StyledGridItem = Styled.div`
    padding: 4px;
    @media (max-width: 768px) {
        padding: 0 16px;

        .gi-dropdown {
            margin-top: 0px;
        }
    }
`;

export const SpannedGridItem = Styled(StyledGridItem)`
    grid-column: span 2;
`;

export const StyledModalGridItem = Styled.div`
    padding: 16px;
    padding-bottom: 0px;
    @media (max-width: 768px) {
        padding: 0 16px;

        .gi-dropdown {
            margin-top: 0px;
        }
    }
`;

export const StyledButtonContainer = Styled.div`
    display: flex;
    gap: 20px;
    margin-top: 30px;
    justify-content: flex-end;
`;

export const StyledModalButtonFooter = Styled.div`
    display: flex;
    gap: 20px;
    justify-content: flex-end;
`;

export const StyledTextArea = Styled.textarea`
    height: auto;
    margin-top: 24px;
    width: 100%;
`;

export const StyledAccordionHeaderContainer = Styled.div`
    display: flex;
    margin: 0.5rem;
    flex-direction: column;
`;

export const StyledAccordionHeader = Styled.div`
    display: flex;
    width: 100%;
`;

export const StyledAccordionHeaderTitle = Styled.div`
    flex: 2;
    font-weight: 600;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryDark};
`;

export const StyledAccordionHeaderTimestamp = Styled.div`
    flex: 1;
    font-size: 13px;
    color: gray;
    font-weight: 400;
`;

export const StyledAccordionHeaderRole = Styled.div`
    flex: 1;
    font-size: 13px;
    color: gray;
    font-weight: 400;
    text-transform: capitalize;
`;

export const StyledAccordionSubHeader = Styled.div`
    font-size: 14px;
`;

export const StyledUserRole = Styled.span`
    text-transform: capitalize;
`;

export const StyledHr = Styled.hr`
    margin: 10px 0;
`;

export const StyledEventContainer = Styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    width: 100%;
    min-height: 3rem;
`;

export const StyledEventKey = Styled.div`
    text-align: right;
    font-size: 12px;
    color: gray;
`;

export const StyledEventValue = Styled.div`
    font-size: 12px;
`;

export const TextEllipsis200 = Styled.span`
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledLabel = Styled.label`
    > span {
        color: red;
    }
`;

export const StyledInputContainer = Styled.div`
    display: flex;
    flex-direction: column;
    > input {
        margin-top: 0px;
        text-align: left;

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        /* Remove Firefox spin buttons */
        &[type='number'] {
            -moz-appearance: textfield;
        }
    }
`;

export const StyledDatePickerContainer = Styled.div`
    .react-datepicker-wrapper {
        width: 100%;

        .react-datepicker__input-container {
            display: flex;
            align-items: center;

            .react-datepicker__calendar-icon {
                padding: 1rem;
            }

            input {
                width: 100%;
                cursor: pointer;
                text-align: left;
            }
        }
    }

    .react-datepicker-popper {
        .react-datepicker__header {
            padding-top: 1em !important;
        }

        .react-datepicker__day-name, .react-datepicker__day {
            width: 1.5em !important;
            line-height: 1.5em !important;
        }

        .react-datepicker__navigation--next {
            left: 190px !important;
        }

        .react-datepicker__current-month {
            padding-bottom: 0.5em !important;
        }

        .react-datepicker__time-container {
            width: 5em !important;

            .react-datepicker__time-list-item {
                padding: 0 !important;
            }
        }
    }
`;

export const StyledError = Styled.div`
    color: red;
    font-size: 12px;
    margin-top: 4px;
`;

export const StyledComment = Styled.p`
    margin: 0;
    font-size: 12px;
`;

export const StyledLink = Styled.a`
    cursor: pointer;
`;

export const StyledCustomDatePickerInput = Styled.input`
    border: ${({ borderSize }) => `${borderSize} solid`};
    border-color: ${({ theme }) => `${theme.gray7}`};
`;

export const StyledCard = Styled(Card)`
    margin-bottom: 1.25rem;
    ${({ isActive }) => !isActive && `border-bottom: none !important;`}
`;

export const StyledCardHeader = Styled(Card.Header)<{ isActive: boolean }>`
    background-color: transparent !important;
    cursor: pointer;
    ${({ isActive }) => isActive && `border-bottom-color: transparent !important;`}
`;

export const StyledAccordion = Styled(Accordion)`
    margin-top: 1.25rem;
    width: auto;
`;

export const StyledScrollElement = Styled(Element)`
    overflow: scroll;
    max-height: 500px;
`;

export const StyledAccordionCollapse = Styled(Accordion.Collapse)<{ isActive: boolean }>`
    .card-body {
        ${({ theme, isActive }) => `
            border-top: 1px solid ${theme.gray7};
            ${isActive ? 'margin: 0px 1.25rem; border-top-width: 1px;' : ''}
        `}
    }
`;
